import { probesFactory, ProbeDefinition, StringProbeDefinition, ProbeOptions } from './probes';
import { TLMDForm, TLMDFormDefinition } from './forms';
import { merge } from '../util/util';

const formConfig = {

}


const SmallTextProbe: StringProbeDefinition = {
	tlmd: {
		probe: {
			id: 'text-small',
			factory: 'string',
			mode: 'single'
		}
	},
	title: 'Small text',
	description: 'Single text line',
	type: ['string', 'null'],
}


//interface PropertyOptions extends ProbeOptions {
//	probe: string;
//}

const probes = {
	[SmallTextProbe.tlmd.probe.id]: SmallTextProbe
}

const ModelingProcess: TLMDFormDefinition = {
	$schema: 'https://json-schema.org/draft/2020-12/schema',
	$id: 'https://ortelium.com/modeling/process.schema.json',
	title: 'Odour Dipersion Modeling Process',
	description: 'A collection of input parameters needed to calculate an odour dispersion model.',
	type: 'object',
	properties: {
		'description': {
			tlmd: { probe: 'text-small' },
			title: 'Description',
			description: 'The description can be used to identiy the process in the viewers',
			default: 'no description',
			maxLength: 100,
//			type: 'string'
		}
	},
	tlmd:{
		'caption': {
			'show': true,
			'showDescription': false,
			'showDescriptionPermanent': false
		}
	}
}



export const testForm = () => {

	let formDefinition = ModelingProcess;

	expandFormOptions(formDefinition);
	console.log(formDefinition);
	let form = new TLMDForm( 'div.tlmd-form-container', formDefinition);
	return form;
}

const expandFormOptions = (def: TLMDFormDefinition): TLMDFormDefinition => {
	Object.keys(def.properties).forEach(propertyKey => {
		let property = def.properties[propertyKey];
		let probeDefinition: ProbeDefinition;

		if ((<string>property.tlmd.probe).toLowerCase) {
			probeDefinition = probes[<string>property.tlmd.probe];
			property.tlmd.probe = probeDefinition.tlmd.probe;
		} else {
			probeDefinition = probes[(<ProbeOptions>property.tlmd.probe).id];
		}

		let expandedProperty = <ProbeDefinition>merge({}, probeDefinition, property);
		def.properties[propertyKey] = expandedProperty;
	})
	return def;
}